export default __webpack_public_path__ + "img/map-marker-pediatric.6ebd027d.png";